export default __webpack_public_path__ + "static/media/Venomshield Belt.35a15ce1.jpg";